<template>
    <div class="WholesaleTemplate">
       <!-- <welcome-popup v-if="$store.getters.isWelcomePopupOpen"/>-->
        <crash-mark-modal-form v-if="$store.getters.hasCrashMarkBeenInitiated"/>
        <side-bar v-if="!isInMobile"/>
        <div id="mainViewport">
            <header-bar/>
            <mobile-bar v-if="isInMobile"/>
            <sort-bar v-if="!isInMobile"/>
            <filter-wrapper v-if="isInMobile && !displayMobileVehicleResults"/>
            <vehicle-scroller v-else-if="!vdpOpen"/>
            <wholesale-footer/>
        </div>
        <login-form v-if="loginForm"/>
        <youtube-video-display v-if="youtubeVideoPlaying"/>
        <delivery-location-display v-if="deliveryLocationIsOnDisplay"/>
        <delivery-location-select v-if="deliveryLocationSelectionOpen"/>
        <router-view></router-view>
        <flash-message/>
        <filter-popup v-if="popupOpen"/>
    </div>
</template>

<script>
    import HeaderBar from '../components/HeaderBar.vue';
    import SideBar from '../components/SideBar.vue';
    import MobileBar from '../components/MobileBar.vue'
    import FilterWrapper from '../components/FilterWrapper.vue';
    import VehicleScroller from '../components/VehicleScroller.vue';
    import SortBar from '../components/SortByBar';
    import LoginForm from '../components/LoginForm.vue';
    import FlashMessage from '../components/FlashMessage';
    import WholesaleFooter from '../components/WholesaleFooter.vue';
    //import WelcomePopup from '../components/WelcomeModal.vue';
    import FilterPopup from '../components/FilterSelectionPopup';
    import CrashMarkModalForm from '../components/CrashMarkModalForm.vue';
    import YoutubeVideoDisplay from '../components/YouTubeVideoDisplay.vue';
    import DeliveryLocationDisplay from '../components/DeliveryLocationDisplay.vue';
    import DeliveryLocationSelect from '../components/DeliveryLocationSelect.vue';

    export default {
        name: 'Wholesale',
        props: [
            'login',
            'dest_zip',
            'vehicle_types',
            'makes',
            'models',
            'colors',
            'priceMin',
            'priceMax',
            'mileageMin',
            'mileageMax',
            'yearMin',
            'yearMax',
            'bobMin',
            'bobMax',
            'buyNow',
            'optMoonroof',
            'optNav',
            'optLeather',
            'optTransmission',
            'optDrive',
            'optBCamera',
            'optDiesel',
            'optCabType',
            'optDoors',
            'searchText',
            'low_mileage',
            'acvMin',
            'acvMax',
            'optThirdRow',
            'optRearEntertainment',
            'mMin'
        ],
        watch: {
            login(current, previous) {
                if(current && current != previous) {
                    this.$store.commit('updateLoginFormVisible', current); 
                }
            }
        },
        components: {
            'header-bar': HeaderBar,
            'side-bar': SideBar,
            'mobile-bar': MobileBar,
            'filter-wrapper': FilterWrapper,
            'vehicle-scroller': VehicleScroller,
            'sort-bar': SortBar,
            'login-form': LoginForm,
            'flash-message': FlashMessage,
            'wholesale-footer': WholesaleFooter,
            //'welcome-popup': WelcomePopup,
            'filter-popup': FilterPopup,
            'crash-mark-modal-form': CrashMarkModalForm,
            'youtube-video-display': YoutubeVideoDisplay,
            'delivery-location-display': DeliveryLocationDisplay,
            'delivery-location-select': DeliveryLocationSelect
        },
        computed: {
            isInMobile() {
                return this.$store.getters.isMobile;
            },
            popupOpen() {
                return this.$store.getters.isFilterSelectOpen;
            },
            popupFilterName() {
                return this.$store.getters.getFilterSelectOpen;
            },
            loginForm() {
                return this.login || this.$store.getters.isLoginFormVisible;
            },
            displayMobileVehicleResults() {
                return this.$store.getters.showMobileVehicleResults;
            },
            vdpOpen() {
                return this.$store.getters.vehicleGallerySelected != null;
            },
            youtubeVideoPlaying() {
                return this.$store.getters.isYoutubeVideoPlaying;
            },
            deliveryLocationIsOnDisplay() {
                return this.$store.getters.isCurrentDeliveryLocationDisplayOpen;
            },
            deliveryLocationSelectionOpen() {
                return this.$store.getters.getDeliveryLocationSelectOpenStatus;
            }
        },
        beforeCreate() {
            console.log("BEFORE CREATE");
            this.$store.dispatch('translateQueryStringFilters', this).then(() => {
                this.$store.dispatch('runSearchQuery');
            });
        },
        beforeRouteUpdate(to, from, next) {
            console.log("BEFORE ROUTE UPDATE");
            if(this.vdpOpen && from.path != to.path && from.path.includes("vdp")) {
                console.log("SETTING VDP TO NULL");
                this.$store.commit('setVehicleGallerySelectedFromRoute', null); //'setVehicleGallerySelected', null);
                this.$store.commit('setOpenGalleryImages', []);
            }
            else {
                console.log("BEFORE ROUTE UPDATE " + this.$store.getters.getRouterQueryStringChange + 
                " TO " + JSON.stringify(to.fullPath) + JSON.stringify(to.path) + JSON.stringify(to.query) + 
                " FROM " + JSON.stringify(from.fullPath) + JSON.stringify(from.path) + JSON.stringify(from.query));
                if(!this.$store.getters.getRouterQueryStringChange) {
                    this.$store.commit('setBrowserButtonActionRunning', true);
                    this.$store.dispatch('translateQueryStringFilters', to.query);
                }
                else {
                    this.$store.commit('routerQueryStringChangePushed', false);
                }
            }

            next();
        },
        /*beforeRouteLeave(to, from, next) {
            console.log("BEFORE ROUTE leave " + 
            " TO " + JSON.stringify(to.fullPath) + JSON.stringify(to.path) + JSON.stringify(to.query) + 
            " FROM " + JSON.stringify(from.fullPath) + JSON.stringify(from.path) + JSON.stringify(from.query));
            next();
        },*/
        methods: {
        }
    }
</script>

<style>
    .WholesaleTemplate {
        display: flex;
        width: calc(100 * var(--vw));
        height: calc(100 *  var(--vh));
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bolder;
        overflow-x: hidden;
        overflow-y: auto;
        font-size: calc(.5vw + ((1 - var(--vratio)) * 1em));
    }

    .inmobile .WholesaleTemplate {
        width: calc(100 * var(--vw));
        max-width: calc(100 * var(--vw));
		font-size: calc(2.1 * var(--vh));
    }

    #mainViewport {
        width: calc(90 * var(--vw));
        height: calc(100 * var(--vh));
        max-width: calc(90 * var(--vw));
        max-height: calc(100 * var(--vh));
        overflow-x: hidden;
        overflow-y: auto;
    }

    .inmobile #mainViewport {
        width: calc(100 * var(--vw));
        max-width: calc(100 * var(--vw));
    }
</style>
